import { h, Component } from 'preact';
import React, { useState, useEffect } from 'react';
import style from './style.scss';
import CustomSwal from '../popupContents/CustomSwal';
import { Event } from '../../utils/events';

class Blocks extends Component {
	constructor(props) {
		super();
		this.state = {
			props    : props,
			basePath : 'https://dev365.gdpventure.com'
		};
	}

	componentDidMount() {}

	formattedData(rawData) {
		const parser = new DOMParser();
		const data = parser.parseFromString(`<!doctype html><body>${rawData}`, 'text/html').body.textContent;
		return data;
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.data !== nextProps.data) {
			this.setState({
				props : nextProps
			});
		}
	}

	render() {
		const description = (props) => {
			return window.matchMedia('(max-width: 900px)').matches ? null : (
				<p class={style.descrip}>{this.formattedData(props.data.field_abstract)}</p>
			);
		};

		const assignedClass = [
			style.newsBlockDiv
		];
		//assignedClass.push(props.type)
		if (this.state.props.type === 'large') {
			assignedClass.push(style.newsBlockLarge);
		}
		else {
			assignedClass.push(style.newsBlockRegular);
		}
		const hiddenClass = [
			style.hiddenImg
		];
		if (this.state.props.data.field_collab === 'true') {
			hiddenClass.push(style.multipleHiddenImg);
		}
		return (
			<div
				class={assignedClass.join(' ')}
				onClick={() => {
					CustomSwal.firePopUpAgain(this.state.props.data, this.props.apisWorking);
				}}
			>
				{/* <div class={style.blockImg}> */}
				<div style="position: relative;" className={style.imgWrapper}>
					<img class={style.blockImg} src={this.state.basePath + this.state.props.data.field_tile_image} />
					{this.state.props.data.field_collab === 'true' ? (
						<div class={style.hiddenImg}>
							<div class={style.multipleImg}>
								<img src={this.state.basePath + this.state.props.data.field_collab_image1} />
							</div>
							<div class={style.crossIcon}>
								<img src="/assets/images/add.png" />
							</div>
							<div class={style.multipleImg}>
								<img src={this.state.basePath + this.state.props.data.field_collab_image2} />
							</div>
						</div>
					) : (
						<div class={style.hiddenImg} onMouseEnter>
							<div class={style.singleImg}>
								<img src={this.state.props.data.field_insight_image} />
							</div>
						</div>
					)}
				</div>
				<div className={style.fieldHeadline}>
					<p class={style.type}>{this.state.props.data.field_connect_type}</p>

					{/* <p class={style.headLine}
           style="font-size: 20px;">{this.state.props.data.field_article_heading}</p> */}
					{window.matchMedia('(max-width: 900px)').matches ? (
						<p class={style.headLine}>{this.formattedData(this.state.props.data.field_article_heading)}</p>
					) : (
						<p class={style.headLine}>{this.formattedData(this.state.props.data.field_article_heading)}</p>
					)}
					{description(this.state.props)}
				</div>
			</div>
		);
	}
	// React.useEffect(()=>{
	//     description(props);
	// },[]);

	// hiddenClass.push(style.hiddenDiv);
	// const hiddenClass = [...assignedClass, style.contentDetails];
}

export default Blocks;



// WEBPACK FOOTER //
// ./components/homeBlock/Blocks.js